import { useMutation, useQueryClient } from "@tanstack/react-query";

import stellar from "@/services/stellar";
import type { ConfigItem } from "../types";
import { CONFIGS_QUERY_KEY } from "./useConfigsQuery";

type UpdateConfigPayload = {
  id: string;
  value: string;
  key?: string;
};

type UpdateConfigResponse = {
  config: ConfigItem;
};

const updateConfig = async ({ id, value, key }: UpdateConfigPayload) => {
  const { config } = (await stellar.action("editConfig", {
    id,
    value,
    key,
  })) as UpdateConfigResponse;

  return config;
};

export const useUpdateConfigMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CONFIGS_QUERY_KEY });
    },
  });
};
